import { Navigate } from 'react-router';
import { ReactNode } from 'react';
import { isAuthenticated } from '@/utils/helpers/authHelpers';
import FRONTEND_ROUTES from '@/consts/frontendRoutes';

interface UnAuthenticatedRouteProps {
  children: ReactNode
}

/**
 * used to wrap routes that should only be accessible to unauthenticated users like the login page
 */
const UnAuthenticatedRoute = ({
  children,
}: UnAuthenticatedRouteProps) => {
  if (isAuthenticated()) {
    return <Navigate to={FRONTEND_ROUTES.DASHBOARD} />;
  }
  return children;
};

export default UnAuthenticatedRoute;
